import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "builder-step-navigation-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isDesktop)
      ? (_openBlock(), _createBlock($setup["BuilderStepDesktopNavigation"], {
          key: 0,
          steps: $props.steps,
          currentStep: $props.currentStep,
          totalPrice: $props.totalPrice,
          errorOnCurrentStep: $props.errorOnCurrentStep,
          builderLogo: $props.builderLogo,
          builderColor: $props.builderColor,
          houseDesign: $props.houseDesign,
          onSelectNext: $setup.onSelectNext,
          onSelectPrev: $setup.onSelectPrev,
          onToggleSummaryModal: $setup.onToggleSummaryModal
        }, null, 8, ["steps", "currentStep", "totalPrice", "errorOnCurrentStep", "builderLogo", "builderColor", "houseDesign"]))
      : _createCommentVNode("", true),
    (!$setup.isDesktop)
      ? (_openBlock(), _createBlock($setup["BuilderStepMobileNavigation"], {
          key: 1,
          steps: $props.steps,
          currentStep: $props.currentStep,
          houseDesign: $props.houseDesign,
          onSelectNext: $setup.onSelectNext,
          onSelectPrev: $setup.onSelectPrev,
          onToggleSummaryModal: $setup.onToggleSummaryModal
        }, null, 8, ["steps", "currentStep", "houseDesign"]))
      : _createCommentVNode("", true)
  ]))
}